
import { Worker as TRWorker } from "twilio-taskrouter";
import { WorkerOptions } from "./types";
import { applyDefaultOptions } from "./utils";



export class Worker extends TRWorker {
    constructor(token: string, options?: WorkerOptions) {
        super(token, applyDefaultOptions(options));
    }
}
